/**
 * The fields a display label actually needs.
 *
 * Narrower than `Vehicle` on purpose: the nested `route.vehicle` summary on
 * `RouteDetail` carries only these three, and it is a legitimate source for a
 * label (TASK-4912). Typing the parameter as the full `Vehicle` would have
 * forced callers that already hold the summary into a needless detail fetch.
 * A full `Vehicle` still satisfies this structurally, so every existing caller
 * is unaffected.
 */
export interface VehicleLabelFields {
  name: string;
  registration_number?: string | null;
}

/**
 * Display label for a vehicle: `Ford Transit · A 1234-7`.
 *
 * The plate is what distinguishes two vehicles of the same model, which is
 * exactly the case a dispatcher has to disambiguate — the name alone was
 * genuinely ambiguous in a mixed fleet (TASK-4827, §7.6).
 *
 * An empty or whitespace-only `registration_number` renders the name alone,
 * never a dangling separator.
 */
export function vehicleLabel(vehicle: VehicleLabelFields): string {
  const plate = (vehicle.registration_number ?? "").trim();
  return plate ? `${vehicle.name} · ${plate}` : vehicle.name;
}
